import { MediaPlayerInstance } from "@vidstack/react";
import React, { createContext } from "react";

export const VideoContext = createContext<React.RefObject<MediaPlayerInstance>>(
  {} as React.RefObject<MediaPlayerInstance>
);
